module.exports = __webpack_public_path__ + "img/controller-ps4.e4feaa37.png";